import { IStoreReview } from '@ugc-components/ugc-store-review/type';

interface IStoreReviewState {
  aboutUsList: IStoreReview[];
  shippingList: IStoreReview[];
  //store-review cms data
  storeReviewStaticLanguage: {
    [key: string]: string;
  };
}

const storeReviewState: IStoreReviewState = {
  aboutUsList: [],
  shippingList: [],
  //store-review cms data
  storeReviewStaticLanguage: {},
};

export default storeReviewState;
